import { createRequiredContext } from '@festina-life/ui/libs'

type ChangesetStateContext = {
  disabledChangesetKeys: string[]
  onDisable: (changesetKeys: string[]) => void
  onEnable: (changesetKeys: string[]) => void
  onReset: () => void
  onDisableAll: () => void
  areAllChangesetsDisabled: boolean
}

const [useChangesetStateContext, Provider] =
  createRequiredContext<ChangesetStateContext>('ChangesetState')

export { Provider, useChangesetStateContext }
